import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "../src/styles/main.scss";
import "../src/styles/swiper.scss";
import VueCookies from "vue-cookies";
import VModal from "vue-js-modal";
import "@/globalComponents"; //used for Skeleton loading
import Cloudinary from "cloudinary-vue";
import cloudinary from "cloudinary-core";
import VueYoutube from "vue-youtube";
import vueVimeoPlayer from "vue-vimeo-player";

Vue.use(VModal, { dialog: true, dynamic: true, injectModalsContainer: true });
Vue.use(VueCookies);
Vue.use(Cloudinary, {
  configuration: {
    cloudName: "avd"
  }
});
Vue.use(VueYoutube);
Vue.use(vueVimeoPlayer);

Vue.config.productionTip = false;
Vue.config.debug = true;
Vue.config.devtools = true;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#productapp");

// Cloudinary
function renderCloudinaryImage() {
    const cl = new cloudinary.Cloudinary({
        cloud_name: "avd"
    });
    cl.responsive();
}
renderCloudinaryImage();